const canvas = document.createElement("canvas");
const textWidthCache: Record<string, number> = {};

/**
 * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
 *
 * @param {String} text The text to be rendered.
 * @param {String} font The css font descriptor that text is to be rendered with (e.g. "bold 14px verdana").
 *
 * @see https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
 */
function getTextWidth(text: string, font: string, options?: { letterSpacing?: string }) {
  const key = `${text}_${font}`;
  if (!textWidthCache[key]) {
    const context = canvas.getContext("2d")!;
    context.font = font;
    if (options?.letterSpacing) {
      // not supported everywhere: https://caniuse.com/mdn-api_canvasrenderingcontext2d_letterspacing
      // @ts-ignore
      context.letterSpacing = options.letterSpacing;
    }
    const metrics = context.measureText(text);
    textWidthCache[key] = metrics.width;
  }
  return textWidthCache[key];
}

export default getTextWidth;
